import Waffle from './Waffle';

export default Waffle;
